import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input} from '@angular/core';
import {forkJoin} from 'rxjs';
import {ActivityViewModel} from '../../../shared/viewModels/activity.viewModel';
import {TrainingViewModel} from '../../../shared/viewModels/training.viewModel';
import {TrainingActivityViewModel} from '../../../shared/viewModels/trainingActivity.viewModel';
import {TrainingDurationViewModel} from '../../../shared/viewModels/trainingDuration.viewModel';
import {UsersService} from '../../../shared/services/users.service';
import {NotificationsService} from '../../../shared/services/notification.service';
import {LocalisationService} from '../../../shared/services/localisation.service';
import {MinutesToReadableTimePipe} from '../../../shared/pipes/minutesToReadableTime.pipe';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {MasterService} from '../../../shared/services/master.service';

@Component({
    selector: 'app-master-training-info-section',
    templateUrl: './training-info-section.component.html',
    styleUrls: ['./training-info-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class MasterTrainingInfoSectionComponent implements OnInit {
    @Input() editable = true;
    @Input() notifications = true;
    @Input() id;

    currentlySelectedActivity: ActivityViewModel;

    trainings: TrainingViewModel[] = [];
    activities: ActivityViewModel[];

    trainingActivities: TrainingActivityViewModel[];
    trainingDurations: TrainingDurationViewModel[];

    constructor(
        private readonly usersService: UsersService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly notificationService: NotificationsService,
        private readonly localisationService: LocalisationService,
        private readonly minutesToReadableTimePipe: MinutesToReadableTimePipe,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly masterService: MasterService,
    ) {
    }

    ngOnInit() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        forkJoin(
            this.masterService.getUserProfile(this.id),
            this.usersService.getMasterTrainings(this.id),
            this.usersService.getUserTrainingActivities(),
            this.usersService.getUserTrainingDurations(),
            this.usersService.getUserActivities(),
        )
            .subscribe(([userProfile, trainings, trainingActivities, trainingDurations, activities]) => {
                this.trainings = trainings;
                this.trainingActivities = trainingActivities;
                this.trainingDurations = trainingDurations;
                this.activities = activities;
                this.currentlySelectedActivity = userProfile.activity ? this.activities.find(a => a.id === userProfile.activity.id) : undefined;

                if (this.trainings.length <= 0) {
                    // this.trainings.push(new TrainingViewModel());
                }

                this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                this.changeDetectorRef.markForCheck();
            });
    }

    updateProfile() {
        let trainingsValidationPassed = true;
        this.trainings.map(training => {
            if (
                !training.day
                || training.day.length <= 0
                || !training.training_activity
                || !training.training_duration
            ) {
                trainingsValidationPassed = false;
            }
        });

        if (!trainingsValidationPassed) {
            this.notificationService.error(this.localisationService.localise('empty_trainings_error'));
            return;
        }

        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        forkJoin([
            this.usersService.updateMasterUserProfile(this.id, {activity: {id: this.currentlySelectedActivity.id}}),
            this.usersService.updateMasterTrainings({trainings: this.convertToTrainingsDTO(), user_id: this.id})
        ])
            .subscribe(() => {
                this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                this.changeDetectorRef.markForCheck();

                if (this.notifications) {
                    this.notificationService.success(this.localisationService.localise('settings_profile_updated_successfully'));
                }
            }, () => {
                this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            });
    }

    addTraining() {
        this.trainings.push(new TrainingViewModel());
        this.changeDetectorRef.markForCheck();
    }

    removeTraining(index: number) {
        this.trainings.splice(index, 1);
        this.changeDetectorRef.markForCheck();
    }

    duplicateTraining(index: number) {
        this.trainings.push({
            day: this.trainings[index].day,
            training_activity: this.trainings[index].training_activity,
            training_duration: this.trainings[index].training_duration,
        });

        this.changeDetectorRef.markForCheck();
    }

    onDayChange(event, index: number) {
        this.trainings[index].day = event.target.value;
        this.changeDetectorRef.markForCheck();
    }

    onTrainingChange(event, index: number) {
        // tslint:disable-next-line:radix
        this.trainings[index].training_activity = this.trainingActivities.find(ta => ta.id === parseInt(event.target.value));
        this.changeDetectorRef.markForCheck();
    }

    onDurationChange(event, index: number) {
        // tslint:disable-next-line:radix
        this.trainings[index].training_duration = this.trainingDurations.find(td => td.id === parseInt(event.target.value));
        this.changeDetectorRef.markForCheck();
    }

    onActivitySelected(activity: ActivityViewModel) {
        this.currentlySelectedActivity = activity;
    }

    convertToTrainingsDTO() {
        const dtoData = [];

        this.trainings.map(training => {
            dtoData.push({
                'day': training.day,
                'training_activity_id': training.training_activity.id,
                'training_duration_id': training.training_duration.id,
            });
        });

        return dtoData;
    }


}
